import { swoopAPI, recommendationApi, publicApi } from '@/api'

export const getOpportunity = opportunityId => swoopAPI.get(`/api/v1/opportunity/${opportunityId}/details`)
// data: {companyId: string}
export const getOpportunitySummary = data => swoopAPI.get('/api/v1/opportunity/summary', { params: data })
// data: {skip: number, take: number, companyId: string}
export const getOpportunityList = data => swoopAPI.get('/api/v1/opportunity/list', { params: data }) // before recommendationApi we used this

import { fundingReasons } from '@/utils/constants'

export const v2RecommendationsUseCases = new Set([fundingReasons.fundingOnboarding])

export const journeysWithoutRecommendations = new Set([fundingReasons.justBrowsing, fundingReasons.businessInsightsAndSavings])

export const getRecommendationsList = (companyId, useCase) => recommendationApi.get(`/recommendations/${companyId}?useCase=${useCase}`)

export const getRecommendationsListV2 = (companyId, useCase) => recommendationApi.get(`/v2/recommendations/${companyId}?useCase=${useCase}`)

export const getRecommendationsListV3 = (companyId, useCase) => recommendationApi.get(`/v3/recommendations/${companyId}?useCase=${useCase}`)

export const getBusinessSuggestions = companyId => recommendationApi.get(`/recommendations/${companyId}/swoop-suggestions`)

export const getInsights = (companyId, useCase) => recommendationApi.get(`/insights/company/${companyId}?useCase=${useCase}`)

export const updateInsights = performActionUrl => recommendationApi.put(`${performActionUrl}`)

export const opportunityCallback = data => swoopAPI.post('/api/v1/opportunity/callback', data)

export const registerInterest = (companyId, groupId, data) => publicApi.post(`/publicapi/companies/${companyId}/group/${groupId}`, data)

export const getProductStatus = (companyId, productId) => recommendationApi.get(`/application/company/${companyId}/product/${productId}/status`)

export const getUmiStatus = (companyId, productId) => recommendationApi.get(`/application/company/${companyId}/product/${productId}/umi/status`)

export const updateUmiStatus = (companyId, productId) => recommendationApi.post(`/application/company/${companyId}/product/${productId}/umi/apply`)

export const submitForReview = (companyId, groupId, applicationId) => publicApi.post(`/publicapi/companies/${companyId}/group/${groupId}/application/${applicationId}/review`)
